"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _types = require("./types");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = _interopRequireDefault(require("./styles"));
var _ThemeProvider = require("baseStyles/ThemeProvider");
var _useClickThrottle = require("hooks/useClickThrottle");
var _colors = require("baseStyles/enums/colors");
var _excluded = ["type", "children", "onClick", "icon", "timeout", "disabled", "dataTestId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getBackground = function getBackground(props, theme) {
  if (props.primary) return {
    backgroundColor: "#4F52C3",
    hover: {
      backgroundColor: "#34389F"
    }
  };
  if (props.secondary) return {
    backgroundColor: "#BDBFF9"
  };
  if (props.primaryFilled) return {
    backgroundColor: theme.primaryFillButton,
    hover: {
      backgroundColor: theme.primaryFillButtonHover
    }
  };
  if (props.secondaryFilled) return {
    backgroundColor: theme.secondaryFillButton,
    hover: {
      backgroundColor: theme.secondaryFillButtonHover
    }
  };
  if (props.bordered) return {
    backgroundColor: "transparent",
    border: "2px solid ".concat(_colors.Colors.PURE_PURPLE, " !important"),
    shadowWidth: 0.001,
    hover: {
      backgroundColor: "#9D9FFC33",
      border: "2px solid ".concat(_colors.Colors.NAVY_BLUE, " !important")
    }
  };
  return {
    backgroundColor: "#EDEDF9"
  };
};
var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-144vacc-0"
})(["display:flex;justify-content:center;align-items:center;gap:10px;flex-shrink:0;border-radius:800px;box-shadow:", ";height:", ";padding:", ";background-color:", ";", ";border:", ";outline:0;box-sizing:border-box;width:", ";transition:all 0.25s;padding-bottom:", "px;padding-top:0px;:hover{background-color:", ";cursor:", ";", ";};:focus{box-shadow:", ";padding-bottom:0px;padding-top:", "px;};", ";"], function (props) {
  return "0px -".concat(props.shadowWidth || 6, "px 0px 0px rgba(0, 0, 0, 0.25) inset !important");
}, function (props) {
  return props.height;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.margin && "margin: ".concat(props.margin);
}, function (props) {
  return props.border || 0;
}, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.shadowWidth;
}, function (props) {
  var _props$hover;
  return props === null || props === void 0 || (_props$hover = props.hover) === null || _props$hover === void 0 ? void 0 : _props$hover.backgroundColor;
}, function (props) {
  var _props$hover2;
  return props === null || props === void 0 || (_props$hover2 = props.hover) === null || _props$hover2 === void 0 ? void 0 : _props$hover2.cursor;
}, function (props) {
  var _props$hover3, _props$hover4;
  return (props === null || props === void 0 || (_props$hover3 = props.hover) === null || _props$hover3 === void 0 ? void 0 : _props$hover3.border) && "border: ".concat(props === null || props === void 0 || (_props$hover4 = props.hover) === null || _props$hover4 === void 0 ? void 0 : _props$hover4.border);
}, function (props) {
  return "0px ".concat(props.shadowWidth || 6, "px 0px 0px rgba(0, 0, 0, 0.25) inset !important");
}, function (props) {
  return props.shadowWidth;
}, function (props) {
  return "".concat((props === null || props === void 0 ? void 0 : props.disabled) && "\n        pointer-events: none;\n        opacity: 0.4;\n    ");
});
var Button = function Button(_ref) {
  var type = _ref.type,
    children = _ref.children,
    onClick = _ref.onClick,
    icon = _ref.icon,
    timeout = _ref.timeout,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = (0, _styles["default"])();
  var _useSuiTheme = (0, _ThemeProvider.useSuiTheme)(),
    theme = _useSuiTheme.theme;
  var background = getBackground(props, theme);
  var throttledOnClick = (0, _useClickThrottle.useClickThrottle)(onClick, timeout);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, _extends({
    "data-test-id": dataTestId,
    onClick: throttledOnClick,
    className: "sui-button"
  }, styles[type] || styles.L, background, props, {
    disabled: disabled,
    "data-sentry-element": "StyledButton",
    "data-sentry-component": "Button",
    "data-sentry-source-file": "index.tsx"
  }), icon, children);
};
Button[_types.ButtonStylesType.XL] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.XL
  }, props));
};
Button[_types.ButtonStylesType.L] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.L
  }, props));
};
Button[_types.ButtonStylesType.M] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.M
  }, props));
};
Button[_types.ButtonStylesType.S] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.S
  }, props));
};
Button[_types.ButtonStylesType.XS] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: _types.ButtonStylesType.XS
  }, props));
};
var _default = exports["default"] = Button;